import React from 'react';

import {LeafType, LeafTypeToFriendlyName} from 'data-types/benchling-type-def/BenchlingTypeDef';
import {LEAF_TYPE_TO_ICON} from 'data-types/benchling-type-def/leafTypeToIcon';
import {ButtonSize} from 'ui-library/buttons/Button';
import SelectDropdown from 'ui-library/dropdowns/SelectDropdown';
import Menu from 'ui-library/menus/Menu';
import {MenuHeight, MenuWidth} from 'ui-library/menus/MenuConstants';
import Option from 'ui-library/menus/Option';

export interface LeafTypeSelectorProps {
  selectedType: LeafType;
  allowedTypes: ReadonlyArray<LeafType>;
  onChange: (type: LeafType) => void;
  disabled?: boolean;
}

/** Dropdown for selecting a LeafType from the provided allowedTypes. */
export default function LeafTypeSelector({
  selectedType,
  allowedTypes,
  onChange,
  disabled,
}: LeafTypeSelectorProps): JSX.Element {
  return (
    <SelectDropdown
      buttonSize={ButtonSize.SMALL}
      displayName={LeafTypeToFriendlyName[selectedType]}
      disabled={disabled}
      menu={
        <Menu height={MenuHeight.SMALL} width={MenuWidth.MEDIUM}>
          {allowedTypes.map((leafType) => (
            <Option key={leafType} value={leafType} icon={LEAF_TYPE_TO_ICON[leafType]} onSelect={onChange}>
              {LeafTypeToFriendlyName[leafType]}
            </Option>
          ))}
        </Menu>
      }
    />
  );
}
